import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import './CancelOrderModal.less';


function CancelOrderModal({ orderTime, onCancelOrder, hideModalFn }) {
  return (
    <div className="cancel-order-modal">
      <div className="modal-header">
        <h3>Cancel This Order</h3>
      </div>
      <div className="modal-body">
        <div className="modal-dek">
          <p>Cancel within {moment(orderTime).add(2, 'h').fromNow(true)}.</p>
        </div>
        <div className="action-buttons">
          <button className="btn btn-secondary btn-wide btn-left" onClick={hideModalFn}>Keep Order</button>
          <button className="btn btn-danger btn-wide btn-right" onClick={onCancelOrder}>Cancel Order</button>
        </div>
      </div>
    </div>
  );
}

CancelOrderModal.propTypes = {
  orderTime: PropTypes.string,
  onCancelOrder: PropTypes.func,
  hideModalFn: PropTypes.func,
};

export default CancelOrderModal;



/** WEBPACK FOOTER **
 ** ./src/cards/components/common/modals/CancelOrderModal/CancelOrderModal.jsx
 **/